<script setup>
import { ref } from 'vue'
import ClassicAuthCard from '../components/ClassicAuthCard.vue'

const props = defineProps({
  identifier: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  registerUrl: { type: String, default: '/register' },
})

const emit = defineEmits(['submit', 'clearError'])
const email = ref(props.identifier)

function submit() {
  const identifier = email.value.trim()
  if (!identifier || props.loading) return
  emit('submit', identifier)
}
</script>

<template>
  <ClassicAuthCard title="Reset Password" :register-url="registerUrl">
    <form class="classic-reset" @submit.prevent="submit">
      <label class="classic-reset__label" for="classic-reset-email">
        Email *
      </label>
      <input
        id="classic-reset-email"
        v-model="email"
        class="classic-reset__input"
        type="email"
        autocomplete="email"
        required
        @input="emit('clearError')"
      >

      <p v-if="error" class="classic-reset__error" role="alert">{{ error }}</p>

      <button class="classic-reset__submit" type="submit" :disabled="loading || !email.trim()">
        {{ loading ? 'Please wait…' : 'Send Password Reset Link' }}
      </button>
    </form>
  </ClassicAuthCard>
</template>

<style scoped>
.classic-reset { display: flex; flex-direction: column; }
.classic-reset__label { color: #333; font-size: 14px; font-weight: 600; margin-bottom: 8px; }
.classic-reset__input { background: transparent; border: 0; border-bottom: 1px solid #c6c6c6; border-radius: 0; box-sizing: border-box; color: #7c7c7c; font: inherit; min-height: 46px; padding: 10px 0; width: 100%; }
.classic-reset__input:focus { border-color: #ff7f5d; box-shadow: none; outline: none; }
.classic-reset__error { color: #dc3545; font-size: 13px; margin: 8px 0 0; }
.classic-reset__submit { align-self: center; background: #ff7f5d; border: 0; border-radius: 25px; color: #fff; cursor: pointer; font: inherit; font-weight: 500; margin-top: 28px; min-width: 260px; padding: 12px 20px; }
.classic-reset__submit:disabled { cursor: not-allowed; opacity: 0.6; }
</style>
